/** Desktop: open content height = tallest feature content. */
export const SPARTAN_FEATURE_SHOWCASE_EXPAND_MIN_HEIGHT_VAR =
  '--spartan-feature-showcase-expand-min-height';

/** Desktop: equal title slot height so titles×n + expand fill the image-matched panel. */
export const SPARTAN_FEATURE_SHOWCASE_TITLE_HEIGHT_VAR =
  '--spartan-feature-showcase-title-height';
